import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import { TextField } from 'redux-form-material-ui';

const NumericRangeFilter = ({ name, title }) => (
  <FormControl>
    <FormLabel>{title}</FormLabel>
    <Field name={`${name}.minValue`} label="Mínimo" type="number" component={TextField} />
    <Field name={`${name}.maxValue`} label="Máximo" type="number" component={TextField} />
  </FormControl>
);

NumericRangeFilter.propTypes = {
  name: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

export default NumericRangeFilter;
